import type { EditionAwarenessContextType } from './edition-awareness-context';

// TODO: Add manual trail as requirement
export function isEligibleForManualFeatureOnboarding(context: EditionAwarenessContextType) {
	const { isInTrial, isInvoiceable, userRoles } = context;

	return Boolean(isInTrial && isInvoiceable && userRoles?.includes('SITE_ADMIN'));
}
